import React from 'react'
// hocs
import withKPI from '../withKPI'
// hooks
import { useModalData, useRefetchTree, useShowModal } from 'hooks'
// components
import { Tab } from '@mui/material'
import { DrawerModal, Tabs } from 'components/UI'
import { LoaderWithOverlay } from 'components/UI/Loader'
import { PlanKPIActionsMenu } from 'components/CTAs'
// view components
import DetailsSection from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection'
import KPIReviewsList from 'components/Modals/PlanItems/KPI/MinimizedModal/components/ReviewsList'
import KPIResultsList from 'components/Modals/PlanItems/KPI/MinimizedModal/components/KPIResultsList'
import QuickResultEnter from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/QuickResultEnter'
import CompleteReview from 'components/Modals/PlanItems/components/CompleteReview'
import ApproveReview from 'components/Modals/PlanItems/components/ApproveReview'
import ActivitiesListContainer from 'containers/Activities/components/ActivitiesList'
import SetColorModal from 'components/Modals/SetColorModal'
// constants
import { ENTITIES, Modals } from 'constants/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { Header, OpenIcon, SubHeader, Wrapper } from 'components/Modals/PlanItems/styles'
// graphql
import { PLAN_KPI_ACTIVITIES_LIST_QUERY } from 'graphql/planKPIs/queries'
// utils
import get from 'lodash/get'
// context
import { KPIContext } from 'context'
// types
import { LogEntityTypes } from 'types/graphql'

const PAPER_PROPS = {
  style: {
    overflowY: 'visible'
  }
}

const KPIMinimizedModal = () => {
  const {
    modalData: { isOpen: isReview }
  } = useModalData({ modalType: Modals.REVIEW_CREATE_MODAL })

  // the result targets modal mounts its own SetColorModal while it is open
  const {
    modalData: { isOpen: isResultTargets }
  } = useModalData({ modalType: Modals.KPI_RESULTS_MODAL })

  const { showModal } = useShowModal({ modalType: Modals.KPI_FULL_MODAL })

  const { hideModal, modalData } = useModalData({ modalType: Modals.KPI_MINIMIZED_MODAL })

  const [tab, setTab] = React.useState(0)

  const { entity, isLoading, plan } = React.useContext(KPIContext)

  const { isOpen, hideMenu } = modalData

  const openFullModal = () => showModal()

  const handleSetTab = (_, value) => setTab(value)

  useRefetchTree()

  return (
    <DrawerModal
      width={'600px'}
      isOpen={isOpen && !isReview}
      hideModal={hideModal}
      PaperProps={PAPER_PROPS}>
      <Header>
        {!isLoading && (
          <>
            <span>{get(entity, 'description')}</span>
            {!hideMenu && <OpenIcon onClick={openFullModal} />}
            <CloseIcon onClick={hideModal} />
          </>
        )}
      </Header>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && entity && (
        <>
          <SubHeader>
            {!hideMenu && !plan.locked && <PlanKPIActionsMenu hideParent={hideModal} />}
            <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
              <Tab label='Details' />
              <Tab label='Activity' />
              <Tab label='Results' />
              <Tab label='Reviews' />
            </Tabs>
          </SubHeader>
          {tab === 0 && (
            <>
              <QuickResultEnter />
              <CompleteReview entity={{ ...entity, entityType: ENTITIES.PLAN_KPI }} />
              <ApproveReview entity={{ ...entity, entityType: ENTITIES.PLAN_KPI }} />
              <Wrapper>
                <DetailsSection
                  entity={{ ...entity, entityType: LogEntityTypes.Kpi }}
                  hideModal={hideModal}
                  modalData={modalData}
                />
              </Wrapper>
            </>
          )}
          {tab === 1 && (
            <ActivitiesListContainer
              entity={{ ...entity, entityType: LogEntityTypes.Kpi }}
              query={PLAN_KPI_ACTIVITIES_LIST_QUERY}
              variables={{
                filter: {
                  entityId: entity.id,
                  actionType: ['CREATE', 'UPDATE', 'DELETE'],
                  entityType: ['IMAGE', 'LINK', 'COMMENT']
                }
              }}
            />
          )}
          {tab === 2 && <KPIResultsList />}
          {tab === 3 && <KPIReviewsList />}
        </>
      )}
      {!isResultTargets && <SetColorModal />}
    </DrawerModal>
  )
}

export default withKPI(KPIMinimizedModal)
